import React from "react";
import { cn } from "../../lib/cn";

export function PageContainer({ className, children }) {
  return (
    <div className={cn("max-w-6xl mx-auto px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </div>
  );
}


